export default "__VITE_ASSET__d27c523d__"